export enum PageState {
    Loading = 'loading',
    Idle = 'idle',
    Submitting = 'submitting',
    Success = 'success',
    Error = 'error',
    Warning = 'warning',
}
